(function () {
  "use strict";

  function formatMoney(cents, formatStr) {
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    var formatted = parts.join(".");
    return (formatStr || "{{amount}}").replace(/\{\{\s*amount\s*\}\}/, formatted);
  }

  function render(totalPriceCents) {
    var el = document.getElementById("FadenShippingProgress");
    if (!el) return;

    var threshold = parseInt(el.getAttribute("data-threshold-cents"), 10) || 200000;
    var moneyFormat = el.getAttribute("data-money-format") || "{{amount}}";
    var textEl = document.getElementById("FadenShippingProgress__text");
    var fillEl = document.getElementById("FadenShippingProgress__fill");
    var wasUnlocked = el.classList.contains("is-unlocked");

    var remaining = threshold - totalPriceCents;
    if (remaining < 0) remaining = 0;
    var pct = Math.min(100, (totalPriceCents / threshold) * 100);
    var unlocked = totalPriceCents >= threshold && totalPriceCents > 0;

    if (fillEl) fillEl.style.width = pct + "%";

    if (unlocked) {
      el.classList.add("is-unlocked");
      if (textEl) {
        textEl.innerHTML =
          '<svg class="faden-check" viewBox="0 0 24 24" fill="none" stroke="#252c1b" stroke-width="2" ' +
          'stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>' +
          "<strong>Congratulations!</strong> Free Shipping Unlocked";
      }
      if (!wasUnlocked) {
        // restart the pulse/shimmer animation for a freshly-unlocked state
        el.classList.remove("is-unlocked");
        void el.offsetWidth;
        el.classList.add("is-unlocked");
      }
    } else {
      el.classList.remove("is-unlocked");
      if (textEl) {
        if (totalPriceCents === 0) {
          textEl.textContent = "Add " + formatMoney(threshold, moneyFormat) + " to unlock Free Shipping";
        } else {
          textEl.innerHTML =
            "Add <strong>" + formatMoney(remaining, moneyFormat) + "</strong> to unlock Free Shipping";
        }
      }
    }
  }

  function refreshFromCart() {
    fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart.total_price); })
      .catch(function () {});
  }

  var CART_ENDPOINT_RE = /\/cart\/(change|update|add|clear)(\.js)?(\?|$)/;

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    return originalFetch.apply(this, arguments).then(function (response) {
      if (CART_ENDPOINT_RE.test(url)) {
        response
          .clone()
          .json()
          .then(function (data) {
            if (data && typeof data.total_price !== "undefined") {
              render(data.total_price);
            } else {
              refreshFromCart();
            }
          })
          .catch(refreshFromCart);
      }
      return response;
    });
  };

  var originalXhrOpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_ENDPOINT_RE.test(url)) {
      this.addEventListener("load", function () {
        try {
          var data = JSON.parse(this.responseText);
          if (data && typeof data.total_price !== "undefined") {
            render(data.total_price);
          } else {
            refreshFromCart();
          }
        } catch (e) {
          refreshFromCart();
        }
      });
    }
    return originalXhrOpen.apply(this, arguments);
  };

  document.addEventListener("DOMContentLoaded", refreshFromCart);
  if (document.readyState !== "loading") refreshFromCart();
})();
